import React from 'react';
import { motion } from 'framer-motion';

interface SectionDividerProps {
  gradient?: boolean;
}

const SectionDivider: React.FC<SectionDividerProps> = ({ gradient = false }) => {
  return (
    <div className="relative py-12 flex items-center justify-center overflow-hidden">
      {gradient ? (
        <motion.div
          initial={{ opacity: 0, scaleX: 0.5 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="w-full max-w-3xl h-[2px]"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.1) 0%, transparent 70%)',
          }}
        />
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="w-full max-w-lg h-[1px]"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.06) 0%, transparent 80%)',
          }}
        />
      )}
    </div>
  );
};

export default SectionDivider;
